export const headCells = [
  {
    id: "created",
    numeric: false,
    disablePadding: true,
    label: "Created",
  },
  {
    id: "name",
    numeric: true,
    disablePadding: false,
    label: "Name",
  },
  {
    id: "phone_number",
    numeric: true,
    disablePadding: false,
    label: "Phone number",
  },
  {
    id: "email",
    numeric: true,
    disablePadding: false,
    label: "Email address",
  },
  {
    id: "city",
    numeric: true,
    disablePadding: false,
    label: "City",
  },
  {
    id: "service",
    numeric: true,
    disablePadding: false,
    label: "Service chosen",
  },
  {
    id: "source",
    numeric: true,
    disablePadding: false,
    label: "Source",
  },
  {
    id: "status",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "last_contacted",
    numeric: true,
    disablePadding: false,
    label: "Last Contacted",
  },
];
export let dashboard = [
  {
    id: 1,
    title: "Today follow up leads",
    name:"today_followup_count",
    list: 0,
  },
  {
    id: 2,
    title: "Leads converted",
    name:"leads_converted_count",
    list: 0,
  },
  {
    id: 3,
    title: "Leads that needs action",
    name:"leads_need_action_count",
    list: 0,
  },
  {
    id: 4,
    title: "Created",
    name:"Created",
    list: 0,
  },
  {
    id: 5,
    title: "Total leads ",
    name:"total_leads",
    list: 0,
  },
  {
    id: 6,
    title: "Total booking appointment ",
    name:"total_booking_appointment",
    list: 0,
  },
  {
    id: 7,
    title: "In progress ",
    name:"in_progress",
    list: 0,
  },
  {
    id: 8,
    title: "Not answered ",
    name:"not_answered",
    list: 0,
  },
  {
    id: 9,
    title: "Not interested ",
    name:"not_interested",
    list: 0,
  },
  {
    id: 10,
    title: "Wellness tips users",
    name:"wellnesstips_count",
    list: 0,
  },
  // {
  //   id: 10,
  //   title: "Converted",
  //   name:"all_data_branched_based",
  //   list: 0,
  // },
];
export let ivfdashboard = [
  {
    id: 1,
    title: "Today follow up leads",
    name:"today_followup_count",
    list: 0,
  },
  {
    id: 2,
    title: "Leads converted",
    name:"leads_converted_count",
    list: 0,
  },
  {
    id: 3,
    title: "Total ivf users",
    name:"total_ivf_patients",
    list: 0,
  },
  {
    id: 4,
    title: "Created",
    name:"Created",
    list: 0,
  },
  {
    id: 5,
    title: "Total leads ",
    name:"total_leads",
    list: 0,
  },
  {
    id: 6,
    title: "Total booking appointment ",
    name:"total_booking_appointment",
    list: 0,
  },
  {
    id: 7,
    title: "In progress ",
    name:"in_progress",
    list: 0,
  },
  {
    id: 8,
    title: "Not answered ",
    name:"not_answered",
    list: 0,
  },
  {
    id: 9,
    title: "Not interested ",
    name:"not_interested",
    list: 0,
  },
  {
    id: 10,
    title: "Wellness tips users",
    name:"wellnesstips_count",
    list: 0,
  },
  // {
  //   id: 10,
  //   title: "Converted",
  //   name:"all_data_branched_based",
  //   list: 0,
  // },
];
export let SpotlightCount = [
  {
    id: 1,
    title: "Total views",
    list: 0,
  },
  {
    id: 2,
    title: "Total link clicks ",
    list: 0,
  },
  {
    id: 3,
    title: "Total time spent",
    list: 0,
  },
  {
    id: 4,
    title: "Unique page views",
    list: 0,
  },
  {
    id: 5,
    title: "Unique link clicks",
    list: 0,
  },
];
export let CitiesCount = [
  {
    id: 1,
    title: "No. of Screen Views Per Day",
    list: 0,
  },
  {
    id: 2,
    title: "No. of Link Clicks Per Day",
    list: 0,
  },
  {
    id: 3,
    title: "No. of Active Users",
    list: 0,
  },
  {
    id: 4,
    title: "Total Screen Views",
    list: 0,
  }
];
export let AudienceCount = [
  {
    id: 1,
    title: "Users Count",
    list: 50,
  },
  {
    id: 2,
    title: "New Users",
    list: 20,
  },
  {
    id: 3,
    title: "Sessions",
    list: 10,
  },
  {
    id: 4,
    title: "Others",
    list: 10,
  }
];
export let SocialAudienceCount = [
  {
    id: 1,
    title: "Users Count",
    list: 0,
  },
  {
    id: 2,
    title: "Female",
    list: 0,
  },
  {
    id: 3,
    title: "Male",
    list: 0,
  },
  {
    id: 4,
    title: "Others",
    list: 0,
  }
];
export let TrendsCount = [
  {
    id: 1,
    title: "Total Conversation",
    list: 0,
  },
  {
    id: 2,
    title: "Total Users",
    list: 0,
  },
  {
    id: 3,
    title: "Automation",
    list: 0,
  }
];
export let DashCount = [
  {
    id: 1,
    title: "Users Count",
    list: 0,
  },
  {
    id: 2,
    title: "New Users ",
    list: 0,
  },
  {
    id: 3,
    title: "Session ",
    list: 0,
  },
  {
    id: 4,
    title: "Others",
    list: 0,
  }
];